import { z } from 'zod'
import { createTransferSchema } from './create-transfer.schema'

export const updateTransferSchema = createTransferSchema.partial().extend({
  // on update an omitted date must leave the stored date unchanged. the base schema defaults
  // date to now (correct for create), and .partial() keeps that default — so a PATCH without a
  // date would silently move the transfer to today. override it to a plain optional with no default.
  date: z.string().datetime({ offset: true }).optional(),
})

export type UpdateTransferDto = z.infer<typeof updateTransferSchema>
